import styled from 'styled-components';

import type { Color } from '#src/style/types.ts';

export const VerticalDivider = styled.div<{ height?: number }>`
  width: 1px;
  height: ${props => (props.height ? `${props.height}px` : '1em')};
  background-color: var(--c-nd-200);
`;

export const HorizontalDivider = styled.div<{ color?: Color }>`
  height: 1px;
  width: 100%;
  background-color: ${props => props.color || 'var(--c-nd-200)'};
`;
